export default {
  primary: '#d22862',
  // lightPrimary: '#FFE4E1',
  lightPrimary: '#e63672',
  // lighterPrimary: '#FFF4F3',
  // lighterPrimary: '#ec5487',
  lighterPrimary: '#e691ae',
  // primaryText: '#FFB3AB',
  primaryText: '#ffd2e1',
  // palePrimary: '#d2286266',
  palePrimary: '#f0c6d4',
  blackText: '#3C3C3C',
  grayText: '#A5A5A5',
  gray: '#C0C0C0',
  lightGray: '#DDDDDD',
  lighterGray: '#EEEEEE',
  brightGray: '#F5F5F5',
  red: '#F25050',
  redHover: '#c82333',
  // green: '#6FCF97',
  green: '#4fc238',
  hoverGreen: '#72bd92',
  lightGreen: '#d4fde5',
  lightYellow: '#fff0d1',
  lightBlue: '#CAECFF',
  lightRed: '#ffcccc',
  blue: '#2D9CDB',
  white: '#FFFFFF',
  yellow: '#ffd800',
  // primaryHover: '#E0665B',
  primaryHover: '#e63672',
  secondary: '#323239',
  secondaryDark: '#3c3c3c',
  black: '#535353',
  solidBlack: '#000',
  backgroundWhite: '#F5F5F5',
  backgroundLightWhite: '#fafafa',
  backgroundGray: '#ebebeb',
  $lightWhite: '#e3e3e359',
  gray: '#6e6e6e',
  // tint: '#2A445D',
  darkGray: '#5a5a61',
  replyBlue: '#6EB2FC',
  replyGray: '#C8C8C8',
  secondaryGreen: '#b3c238',
  whiteOpacity: 'rgba(255 ,255, 255, 0.75)',
  boxShadow: '4px 4px 20px 0px rgba(0,0,0,0.08)',
  boxShadowHover: '5px 5px 20px 0px rgba(0,0,0,0.2)',
  blackOpacity: 'rgba(0, 0, 0, .5)',
};
